module.exports = __webpack_public_path__ + "static/img/error.65a9be9c.png";